import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getPatientQuery } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/appointmentSlice";

const UsePatientQuery = (prescriptionId) => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ["getPatientQuery", prescriptionId],
        queryFn: () => getPatientQuery(prescriptionId),
        enabled: !!prescriptionId,
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UsePatientQuery;
